import React, { useState, useEffect } from "react"
import styled, { ThemeProvider, createGlobalStyle } from "styled-components"
import { withWindow } from "react-window-decorators"

import { sLayout } from "../styled/layout"

import Header from "./header"
import Footer from "./footer"
import Menu from "./menu"

import useSiteMetadata from "../hooks/use-site-metadata"

const GlobalStyles = createGlobalStyle`
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  html {
    height: 100%;
  }

  body {
    color: ${props => props.theme.colors.grey};
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    margin: 0;
    padding: 0;
  }

  h1,h2,h3,h4,h5,h6 {
    margin: 0;
  }

  figure {
    margin: 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  address {
    font-style: normal;
  }

  fieldset {
    border: none;
    margin: 0;
    padding: 0;
  }

  .visuallyhidden {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  .visuallyhidden.focusable:active,
  .visuallyhidden.focusable:focus {
      clip: auto;
      height: auto;
      margin: 0;
      overflow: visible;
      position: static;
      width: auto;
  }

  [class^="icon-"]:before, [class*=" icon-"]:before {
    margin: 0;
    width: auto;
  }

  input, select, button {
    font-family: 'Open Sans', sans-serif;
  }

  button {
    font-family: 'Open Sans', sans-serif;
    padding: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: 0;
    border-radius: 0;
    background: transparent;
    letter-spacing: $letter-spacing;
    line-height: 1;
    cursor: pointer;

    &:focus {
        outline: none;
    }
  }

  .swiper-container {
    .swiper-pagination {
      margin-top: 20px;
      position: static;

      @media only screen and (min-width: ${props => props.theme.mq.small}) {
        margin-top: 30px;
      }

      .swiper-pagination-bullet-active {
        background-color: ${props => props.theme.colors.primary};
      }
    }
  }  
`

const Body = styled.div`
  margin-top: 35px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    margin-top: 60px;
  }
`

const Layout = props => {
  const { color } = useSiteMetadata()
  const [vh, setVh] = useState(0)
  const [openMenu, setOpenMenu] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setVh(window.innerHeight * 0.01)
    }

    window.addEventListener(`resize`, handleResize)

    handleResize()

    return () => {
      window.removeEventListener(`resize`, handleResize)
    }
  }, [])

  const toggleMenu = () => {
    setOpenMenu(openMenu === false)
  }

  const { children, isTouchDevice } = props

  const theme = {
    colors: {
      primary: color || `#1aa799`,
      grey: `#444`,
      lightgrey: `#595959`,
    },
    mq: {
      xsmall: `600px`,
      small: `768px`,
      medium: `1000px`,
    },
    units: {
      vh,
    },
    title: {
      lhd: `1.4`,
      w: `600`,
    },
    text: {
      lhd: `1.6`,
      lhm: `1.4`,
      sd: `17px`,
      sm: `15px`,
      w: `300`,
    },
  }

  return (
    <ThemeProvider theme={theme}>
      <div className={isTouchDevice.toString() === `true` ? `touchevents` : `no-touchevents`}>
        <GlobalStyles suppressMultiMountWarning />
        <Header toggleMenu={toggleMenu} />
        <Body>
          <sLayout.Container>{children}</sLayout.Container>
        </Body>
        <Footer />
        <Menu toggleMenu={toggleMenu} open={openMenu} />
      </div>
    </ThemeProvider>
  )
}

export default withWindow(Layout)
